
export const DataAiCertificationsData = [
  {
    title: "Databricks Certified",
    icon: "/images/Programs/pg_icon1.png",
    items: [
      { name: "Data Analyst Associate", url: "https://www.databricks.com/learn/certification/data-analyst-associate" },
      { name: "Data Engineer Associate", url: "https://www.databricks.com/learn/certification/data-engineer-associate" },
      { name: "Data Engineer Professional", url: "https://www.databricks.com/learn/certification/data-engineer-professional" },
      { name: "Machine Learning Associate", url: "https://www.databricks.com/learn/certification/machine-learning-associate" },
      { name: "Generative AI Engineer", url: "https://www.databricks.com/learn/certification/genai-engineer-associate" },
    ],
  },
  {
    title: "Neo4j",
    icon: "/images/Programs/pg_icon2.png",
    items: [
      { name: "Certified Professional", url: "https://graphacademy.neo4j.com/certifications/neo4j-certification/" },
      { name: "Graph Data Science Certification", url: "https://graphacademy.neo4j.com/certifications/gds-certification/" },
    ],
  },
  {
    title: "Confluent Certified",
    icon: "/images/Programs/pg_icon3.png",
    items: [
      { name: "Developer for Apache Kafka", url: "https://training.confluent.io/examdetail/confluent-dev" },
      { name: "Administrator for Apache Kafka", url: "https://training.confluent.io/examdetail/confluent-admin-exam" },
    ],
  },
   {
    title: "Claude",
    icon: "/images/Programs/pg_icon6.png",
    items: [
      { name: "The Claude Certified Architect", url: "" },
    ],
  },
  {
    title: "Talend",
    icon: "/images/Programs/pg_icon4.png",
    items: [
      { name: "Data Integration Certified Developer", url: "https://www.talend.com/academy/certification/data-integration-certified-developer-exam/" },
      { name: "Big Data Certified Developer", url: "https://www.talend.com/academy/certification/big-data-certified-developer-exam/" },
    ],
  },
  {
    title: "Alteryx",
    icon: "/images/Programs/pg_icon5.png",
    items: [
      { name: "Alteryx Designer Core", url: "https://community.alteryx.com/t5/Certification-Resources/Designer-Core-Certification-Exam-Prep-Guide/ta-p/409403" },
      { name: "Advanced Certification", url: "https://community.alteryx.com/t5/Certification-Resources/Designer-Advanced-Certification-Exam-Prep-Guide/ta-p/409406" },
    ],
  },
   {
    title: "Snowflake",
    icon: "/images/Programs/pg_icon7.png",
    items: [
      { name: "SnowPro Core Certification", url: "https://learn.snowflake.com/en/certifications/snowpro-core/" },
    ],
  },
];
